Monitoring.Views ||= {}

class Monitoring.Views.GenericAvatarView extends Backbone.View
  template: JST['backbone/templates/generic_avatar']

  initialize: ({socialContent}) ->
    @avatar = socialContent.avatar()
    type = socialContent.type()
    subType = socialContent.subType()
    @defaultImg = @_defaultImage(type, subType)
    @_replaceDefaultEmailAvatar()

  render: =>
    @$el.html @template
      view_id: @cid
      avatar_url: @avatar || @defaultImg
      default_img: @defaultImg

  _replaceDefaultEmailAvatar: ->
    return unless @_usesDefaultEmailAvatar()
    @avatar = window.image_path('mail-default-avatar.png')

  _usesDefaultEmailAvatar: ->
    @avatar == '/assets/mail-default-avatar.png'

  _defaultImage: (type, subType) ->
    return window.image_path('chat-brand.png') if type == 'webchat'
    window.default_avatar_for(subType) || window.image_path('man_user.png')
